import React from 'react';
import { Box, Typography } from '@mui/material';
import ConfigPanel from './ConfigurationPanel/ConfigPanel';

const Configuration: React.FC = () => {
  return (
    <Box sx={{ p: 4 }}>
      <Typography variant="h4">Configuration (Coming Soon)</Typography>
      <ConfigPanel />
    </Box>
  );
};

export default Configuration;
